import React from "react";
import { CContainer, CSpinner } from "@coreui/react";

export default function LoadingScreen() {
  return (
    <CContainer
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "50vh" }}
    >
      <CSpinner />
    </CContainer>
  );
}

